<template>
  <div>
    <el-form ref="form" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="实验类型:">
            <el-select
              v-model="labId"
              @change="changelabs($event)"
              placeholder="请选择"
            >
              <el-option
                v-for="item in lablistData"
                :key="item.labId"
                :label="item.name"
                :value="item.labId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="5" v-if="($store.state.usuerdata.role = 64)">
          <el-form-item label="班级:">
            <el-select
              v-model="classId"
              @change="changeclass($event)"
              placeholder="请选择"
            >
              <el-option
                v-for="item in classlistData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="">
            <el-button type="primary">搜索</el-button>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>

    <el-table :data="tableData">
      <el-table-column prop="name" label="学生姓名"> </el-table-column>
      <el-table-column
        v-for="(item, index) in activeLabData"
        :key="index"
        :prop="item"
        :label="item"
      >
      </el-table-column>
      <el-table-column prop="score" label="总分"> </el-table-column>
      <el-table-column prop="status" label="状态"> </el-table-column>
    </el-table>

    <el-dialog title="编辑账号" :visible.sync="edVisible" width="30%">
      <el-form
        label-width="120px"
        :model="edfromData"
        :rules="edrules"
        ref="edForm"
      >
        <el-form-item label="新姓名" prop="new_name">
          <el-input
            size="small"
            v-model="edfromData.new_name"
            auto-complete="off"
            placeholder="请输入新姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="原密码" prop="old_password">
          <el-input
            size="small"
            v-model="edfromData.old_password"
            auto-complete="off"
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input
            size="small"
            v-model="edfromData.new_password"
            auto-complete="off"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="edVisible = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitFormed('edForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  myinfos,
  schoollist,
  myedit,
  lablist,
  scorequeryself,
  classlist,
} from "@/api/userMG";
export default {
  name: "index",
  data() {
    return {
      user: {},
      listData: [],
      labId: "",
      classId: "",
      edfromData: {
        old_password: "",
        new_password: "",
        new_name: "",
      },
      loading: false, //是显示加载
      edrules: {
        old_password: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        new_name: [
          { required: true, message: "请输入新姓名", trigger: "blur" },
        ],
      },
      edVisible: false,
      lablistData: [],
      activeLabData: [],
      classlistData: [],
      tableData: [],
    };
  },
  created() {
    this.getmyinfos();
    this.getdata();
    this.getlablist();
    // if ((this.$store.state.usuerdata.role = 64)) {
    //   this.getClass();
    // } else {
    // }
  },
  methods: {
    changeclass() {},
    changelabs(e) {
      this.labId = e;
      this.activeLabData = [];
      let index = this.lablistData.findIndex((item) => {
        return item.labId == e;
      });
      this.activeLabData = this.lablistData[index].title;
      this.getscorequeryself(e);
    },
    getClass() {
      classlist().then((res) => {
        this.classlistData = [];
        this.classlistData = res;
      });
    },
    getscorequeryself(params) {
      this.tableData = [];
      scorequeryself(params).then((res) => {
        let data = {
          name: this.$store.state.usuerdata.name,
        };
        if (res) {
          if (res.scores.length > 0) {
            this.activeLabData.forEach((item, index) => {
              if (res.scores[index] >= 0) {
                Reflect.set(data, item, res.scores[index]);
                Reflect.set(data, "status", res.status);
                Reflect.set(data, "accountId", res.accountId);
                Reflect.set(data, "score", res.score);
                Reflect.set(
                  data,
                  "status",
                  res.status == 1 ? "完成" : "未完成"
                );
              }
            });
          }
          this.tableData.push(data);
        }
      });
    },
    getlablist() {
      lablist().then((res) => {
        this.lablistData = res;
        this.labId = res[0].labId;
        this.activeLabData = this.lablistData[0].title;
        this.getscorequeryself(res[0].labId);
      });
    },
    handleEdit() {
      this.edVisible = true;
      this.edfromData.old_password = "";
      this.edfromData.new_password = "";
      this.edfromData.new_name = "";
      this.edfromData.new_name = this.user.name;
    },
    submitFormed(edForm) {
      this.$refs[edForm].validate((valid) => {
        if (valid) {
          myedit(this.edfromData)
            .then((res) => {
              this.edVisible = false;
              this.loading = false;
              this.$message({
                type: "success",
                message: "修改成功！",
              });
              this.getmyinfos();
            })
            .catch((err) => {
              this.edVisible = false;
              this.loading = false;
              this.$message.error(err.response.data.msg);
            });
        }
      });
    },
    getmyinfos() {
      myinfos().then((res) => {
        this.user = {};
        this.user = res;
      });
    },
    getdata() {
      schoollist().then((res) => {
        this.listData = [];
        this.listData = res;
        console.log(res, "resss");
      });
    },
  },
};
</script>
<style  scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row :last-child {
  margin-bottom: 0;
}
.el-col {
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  min-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/views/shiyan/shiyan.vue